import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
const NotFound = (props) => (
    <Segment basic>
        <Header>404: Page Not Found</Header>
    </Segment>
);

export default NotFound;
